export default "__VITE_ASSET__44a186d5__"